var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.525 13.3H.475a.475.475 0 00-.475.475v.95c0 .262.213.475.475.475h18.05a.475.475 0 00.475-.475v-.95a.475.475 0 00-.475-.475zM2.391 10.131a.98.98 0 00.723.318l3.875-.005c.306 0 .607-.073.88-.211l8.638-4.384c.794-.403 1.505-.978 1.99-1.73.543-.846.602-1.458.388-1.89-.214-.433-.735-.75-1.73-.815-.886-.058-1.767.175-2.561.578l-2.925 1.484L5.177 1.04a.528.528 0 00-.535-.033l-1.952.99a.542.542 0 00-.153.848l4.638 2.912L4.11 7.312 1.963 6.229a.529.529 0 00-.477 0l-1.192.606a.543.543 0 00-.165.833l2.262 2.463z",
    fill: "#A28D50"
  })));
}

export default SvgCheckOut;